import { useState } from "react";
import { useToast } from "../../hooks/ToastContext";

// Dial codes offered in the registration form. WhatsApp needs a full
// international number; without a code here the backend can only guess.
const COUNTRY_CODES = [
  { code: "91", iso: "IN", name: "India" },
  { code: "1", iso: "US", name: "USA / Canada" },
  { code: "44", iso: "GB", name: "United Kingdom" },
  { code: "61", iso: "AU", name: "Australia" },
  { code: "65", iso: "SG", name: "Singapore" },
  { code: "971", iso: "AE", name: "United Arab Emirates" },
  { code: "60", iso: "MY", name: "Malaysia" },
  { code: "64", iso: "NZ", name: "New Zealand" },
  { code: "27", iso: "ZA", name: "South Africa" },
  { code: "234", iso: "NG", name: "Nigeria" },
  { code: "254", iso: "KE", name: "Kenya" },
  { code: "92", iso: "PK", name: "Pakistan" },
  { code: "880", iso: "BD", name: "Bangladesh" },
  { code: "94", iso: "LK", name: "Sri Lanka" },
  { code: "977", iso: "NP", name: "Nepal" },
  { code: "63", iso: "PH", name: "Philippines" },
  { code: "62", iso: "ID", name: "Indonesia" },
  { code: "66", iso: "TH", name: "Thailand" },
  { code: "84", iso: "VN", name: "Vietnam" },
  { code: "49", iso: "DE", name: "Germany" },
  { code: "33", iso: "FR", name: "France" },
  { code: "34", iso: "ES", name: "Spain" },
  { code: "39", iso: "IT", name: "Italy" },
  { code: "31", iso: "NL", name: "Netherlands" },
  { code: "55", iso: "BR", name: "Brazil" },
  { code: "52", iso: "MX", name: "Mexico" },
  { code: "966", iso: "SA", name: "Saudi Arabia" },
  { code: "20", iso: "EG", name: "Egypt" },
];

// Flag emoji are built from the ISO code's regional indicator letters, so no
// image assets or extra requests are needed.
const flagEmoji = (iso) =>
  String(iso || "")
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

// Store the number the way WATI needs it: country code + national number,
// digits only, no leading zero.
const toInternational = (countryCode, national) => {
  const cc = digitsOnly(countryCode);
  let local = digitsOnly(national).replace(/^0+/, "");
  if (!local) return "";
  if (local.startsWith(cc)) local = local.slice(cc.length);
  return cc + local;
};

function FeRegister({
  contestPageDetails,
  signinEntry,
  inputs,
  setInputs,
  feRegister,
  clickloginBtn,
  isRegLoading,
  enddateError,
  lang,
}) {
  //const contest_setup =  JSON.stringify(contestPageDetails);
  const { showToast } = useToast();
  let entrydet;
  if (signinEntry.entry) {
    entrydet = JSON.parse(signinEntry.entry);
  }

  const [countryCode, setCountryCode] = useState("91");
  const [nationalPhone, setNationalPhone] = useState("");

  const handleChange = (e) => {
    setInputs((inputs) => {
      return {
        ...inputs,
        [e.target.name]: e.target.value,
        phone_status: entrydet?.phone_status,
      };
    });

    // console.log("AAS"+inputs);
  };

  // inputs.phone always holds the full international number, so the payload
  // and the parent's feRegister() need no changes.
  const syncPhone = (cc, local) => {
    setInputs((inputs) => ({
      ...inputs,
      phone: toInternational(cc, local),
      country_code: digitsOnly(cc),
      phone_status: entrydet?.phone_status,
    }));
  };

  const handleCountryChange = (e) => {
    setCountryCode(e.target.value);
    syncPhone(e.target.value, nationalPhone);
  };

  const handlePhoneChange = (e) => {
    setNationalPhone(e.target.value);
    syncPhone(countryCode, e.target.value);
  };

  const register = () => {
    const phoneRegEx = /^\+?[1-9]\d{1,14}$/;

    // Email Validation Regex Pattern
    const validateEmail = (email) => {
      return /\S+@\S+\.\S+/.test(email);
    };

    if (!inputs.name?.trim()) {
      showToast("warning", "Name should not be empty");
      return;
    }
    if (!inputs.email?.trim()) {
      showToast("warning", "Email should not be empty");
      return;
    }
    if (!validateEmail(inputs.email)) {
      showToast("warning", "Please enter a valid Email");
      return;
    }

    if (entrydet.phone_status) {
      if (!nationalPhone.trim()) {
        showToast("warning", "Phone should not be empty");
        return;
      }
      const full = toInternational(countryCode, nationalPhone);
      // E.164: country code plus 4-14 more digits.
      if (!phoneRegEx.test(full) || full.length < 8 || full.length > 15) {
        showToast("warning", "Please enter a valid phone number");
        return;
      }
    }

    /* if (!inputs.password?.trim()) {
            showToast("warning", "Password Should not empty");
            return;
        } else {
            const length = inputs.password.length;
            if (length < 8) {
                showToast("warning", "Password Minimum 8 characters");
                return;
            }

        } */
    /* if (!inputs.confirm_password?.trim()) {
            showToast("warning", "Confirm Password Should not empty");
            return;
        } else if (inputs.confirm_password !== inputs.password) {
            showToast("warning", "Confirm Password doesn't Match");
            return;
        } */
    feRegister();
  };

  return (
    <div className=" relative flex justify-center items-center md:p-8">
      <div className=" md:mt-[-135px] mt-[-90px] md:pb-3 pb-8">
        <div className="w-[280px] md:w-[648px] bg-white shadow-md rounded-lg opacity-100">
          <div className="primary_light_bgcolor2 bg-[#E1EDF9] p-6 text-center rounded-t-lg">
            <h2 className="text-center text-black md:text-[17px] sm:leading-[20px] sm:text-[12px] font-medium opacity-100 md:mb-2">
              {entrydet?.register_title}
            </h2>
            <h4 className="text-[13px] md:p-1 leading-4 text-black/60">
              {entrydet?.register_sub_title}
            </h4>
          </div>

          <div className="p-4 md:p-10">
            <div className="mb-5">
              <label
                htmlFor="name"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                {entrydet?.name || "Enter Your Name"}
                <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                onChange={handleChange}
                className="bg-white input_focus_primary border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder={entrydet?.name || "Enter Your Name"}
                required
              />
            </div>
            <div className="mb-5">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                {entrydet?.email || "Enter Your Email"}
                <span class="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                onChange={handleChange}
                className="bg-white input_focus_primary border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder={entrydet?.email || "Enter Your Email"}
                required
              />
            </div>
            {entrydet?.phone_status === 1 && (
              <div className="mb-5">
                <label
                  htmlFor="phone-input"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  {entrydet?.phone || "Phone Number"}
                  <span class="text-red-500">*</span>
                </label>
                <div className="flex items-center">
                  {/* <button className="shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100" type="button">
                                    +91
                                    <svg className="w-2.5 h-2.5 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                    </svg>
                                </button> */}
                  <select
                    id="country_code"
                    name="country_code"
                    value={countryCode}
                    onChange={handleCountryChange}
                    aria-label="Country code"
                    className="bg-white input_focus_primary border border-gray-300 border-e-0 text-gray-900 text-sm rounded-s-lg focus:ring-blue-500 focus:border-blue-500 py-2.5 pl-2.5 pr-7 shrink-0"
                  >
                    {COUNTRY_CODES.map((country) => (
                      <option
                        key={country.iso}
                        value={country.code}
                        title={`${country.name} (+${country.code})`}
                      >
                        {flagEmoji(country.iso)} +{country.code}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    inputMode="numeric"
                    id="phone"
                    name="phone"
                    value={nationalPhone}
                    onChange={handlePhoneChange}
                    className="bg-white input_focus_primary border border-gray-300 text-gray-900 text-sm rounded-e-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder={entrydet?.phone || "Enter Your Phone"}
                    required
                  />
                </div>
              </div>
            )}
            {/* <div className="mb-5">
                            <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900">{entrydet?.password || 'Enter Your Password'}<span class="text-red-500">*</span></label>
                            <input type="password" id="password" name="password" onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder={entrydet?.password || 'Enter Your Password'} required />
                        </div> */}
            {/* <div className="mb-5">
                            <label htmlFor="confirm_password" className="block mb-2 text-sm font-medium text-gray-900">{entrydet?.confirm_password || 'Enter Your Confirm Password'}<span class="text-red-500">*</span></label>
                            <input type="password" id="confirm_password" onChange={handleChange} name="confirm_password" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder={entrydet?.confirm_password || 'Enter Your Confirm Password'} required />
                        </div> */}

            <div className="w-full mt-5">
              <div className="relative w-full inline-block group">
                {/* Full-width Button */}
                <button
                  onClick={() => register()}
                  disabled={isRegLoading || enddateError === 1}
                  className="w-full primary_btn_bg bg-[#0274F7] text-white font-bold text-[14px] leading-[25px] tracking-[0px] p-3 rounded-md border transition duration-200 
                 hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7] 
                 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {entrydet?.register_btn_text || "Register Now"}
                </button>

                {/* Tooltip */}
                {enddateError === 1 && (
                  <div
                    className="
  absolute left-1/2 -top-12 -translate-x-1/2 
  bg-gray-900 text-white text-sm px-4 py-2 rounded 
  opacity-0 group-hover:opacity-100 transition-opacity duration-200
  whitespace-nowrap z-50
"
                  >
                    {lang?.contest_end_tooltip_text ||
                      "Registration for the contest is currently closed.  \n If you have already signed up, you can sign in to access your rewards and prizes."}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeRegister;
